
export default function Input({ onChange, value, label, placeholder, inputMode, type = "text" }) {
	return (
		<div className="relative">
			<input
				type={type}
				value={value ?? ""}
				onChange={onChange}
				className="peer w-full rounded-[12px] border border-darkBlue/15 bg-white px-4 pb-2 pt-6 font-Vazir-400 text-[14px] text-darkBlue outline-none transition placeholder:text-transparent focus:border-darkBlue/35 focus:ring-2 focus:ring-cta/15"
				placeholder={placeholder || label}
				inputMode={inputMode || "text"}
			/>
			<label className="pointer-events-none absolute right-4 top-2 font-Vazir-400 text-[12px] text-darkBlue/55 transition peer-focus:text-darkBlue/70">
				{label}
			</label>
		</div>
	);
}
